module.exports = __webpack_public_path__ + "static/media/logo.d753cfd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 219
// module chunks = 0